'use client';

import { COLORS } from '@/constants';
import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ListTitle = styled(Typography)`
  && {
    font-weight: 600;
    font-size: 1.5rem;
    margin: 0;
    color: ${COLORS['primary/900']};
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
